/**
 * 常量映射表
 */
export default {
  // oneApi 登录态过期code值映射
  loginExpiredCode: 9,
}
